import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shoelace-carousel"
export default class extends Controller {
  goToSlide(event) {
    const index = event.params.index;
    this.carouselElement.goToSlide(index);

    const selectedItem = this.carouselItems[index];

    if (selectedItem.hasAttribute("inert")) {
      selectedItem.removeAttribute("inert");
    }
  }

  get carouselElement() {
    return this.element.querySelector("sl-carousel");
  }

  get carouselItems() {
    return this.carouselElement.querySelectorAll("sl-carousel-item");
  }
}
